import React from "react";
import { useTranslation } from "react-i18next";
import PublicLayout from "@/components/PublicLayout";
import { useLocale, pickLocalized } from "@/contexts/LocaleContext";
import { api } from "@/lib/api";

export default function About() {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const [page, setPage] = React.useState(null);
  React.useEffect(() => {
    api.get("/public/pages/about").then((r) => setPage(r.data)).catch(() => {});
  }, []);
  const data = page?.sections?.[locale] || page?.sections?.hr || {};

  return (
    <PublicLayout pageTitle={data.title || t("nav.about")} testid="about-page">
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-20">
        <p className="text-xs uppercase tracking-[0.3em] text-primary/80">— {t("nav.about")}</p>
        <h1 className="font-display text-5xl sm:text-6xl mt-3" data-testid="about-title">
          {data.title}
        </h1>
        <div
          className="prose prose-invert prose-headings:font-display max-w-none mt-10 text-base sm:text-lg leading-relaxed [&_p]:mb-5 [&_a]:text-primary [&_strong]:text-foreground"
          data-testid="about-body"
          dangerouslySetInnerHTML={{ __html: data.body_html || "" }}
        />
      </section>
    </PublicLayout>
  );
}
